var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.884 40.884",
    fill: "var(--iconColor)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.357 16.574h4.256v13.471h-4.256z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.484,
    cy: 13.029,
    r: 2.127
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.218 22.836c0-3.54-.766-6.261-4.911-6.261a4.3 4.3 0 0 0-3.873 2.122h-.056v-1.8h-3.927v13.147h4.093v-6.5c0-1.713.325-3.375 2.455-3.375 2.1 0 2.128 1.961 2.128 3.486v6.391h4.091zM20.443 1.699c10.351.001 18.742 8.393 18.741 18.744S30.792 39.185 20.44 39.185 1.698 30.793 1.698 20.442A18.77 18.77 0 0 1 20.443 1.699m0-1.7a20.442 20.442 0 1 0 7.822 39.328 20.44 20.44 0 0 0 12.619-18.886C40.884 9.152 31.732 0 20.443-.001z"
  })));
};
export default SvgLinkedin;